import CopperCoinSvg from './CopperCoinSvg';

export default CopperCoinSvg;

export { CopperCoinSvg };
